import React from 'react'
import laborotoriya1 from '../fayl/laborotoriya/1.pdf'
import laborotoriya2 from '../fayl/laborotoriya/2.pdf'
import laborotoriya3 from '../fayl/laborotoriya/3.pdf'
import laborotoriya4 from '../fayl/laborotoriya/4.pdf'
import laborotoriya5 from '../fayl/laborotoriya/5.pdf'
import laborotoriya6 from '../fayl/laborotoriya/6.pdf'
import laborotoriya7 from '../fayl/laborotoriya/7.pdf'
import { Button, Dropdown } from 'antd'

const items =[
    {
        key: '1',
        label: (
            <a href={laborotoriya1}>1-laboratoriya</a>
        ),
    },
    {
        key: '2',
        label: (
            <a href={laborotoriya2}>2-laboratoriya</a>
        ),
    },
    {
        key: '3',
        label: (
            <a href={laborotoriya3}>3-laboratoriya</a>
        ),
    },
    {
        key: '4',
        label: (
            <a href={laborotoriya4}>4-laboratoriya</a>
        ),
    },
    {
        key: '5',
        label: (
            <a href={laborotoriya5}>5-laboratoriya</a>
        ),
    },
    {
        key: '6',
        label: (
            <a href={laborotoriya6}>6-laboratoriya</a>
        ),
    },
    {
        key: '7',
        label: (
            <a href={laborotoriya7}>7-laboratoriya</a>
        ),
    },
]

const Laborotoriya = () => {
    return (
        <div>
            <Dropdown  menu={{ items }} placement='bottom' arrow={{ pointAtCenter: true }}>
                <Button className='button'>Laboratoriya mashg'ulotlari</Button>
            </Dropdown>
        </div>
    )
}

export default Laborotoriya